<template>
  <div class="navbar">
    <div class="hamburger-container" @click="toggleSideBar">
      <svg
        :class="{ 'is-active': sidebar.opened }"
        class="hamburger"
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
      >
        <path
          d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
        />
      </svg>
    </div>
    <breadcrumb class="breadcrumb-container" />
    <el-button v-if="!isStationAdmin" class="refresh-btn" icon="el-icon-refresh" :loading="cacheLoading" @click="refreshCache">
      更新缓存
    </el-button>
    <div class="u-flex u-m-r-20" style="float: right; height: 100%; align-items: center">
      <el-tag v-if="isStationAdmin" type="info" size="medium">{{ substationName || '本驿站' }}</el-tag>
      <el-select
        v-else
        v-model="subSiteIdLocal"
        placeholder="请选择驿站"
        style="width: 150px"
        @change="onSubstationChange"
      >
        <el-option
          v-for="item in subSiteList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div>
    <div class="right-menu">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="avatar-wrapper el-dropdown-link">
          {{ name }}<i class="el-icon-caret-bottom" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { clearCache } from '@/api/config'
import { canLoadSubsiteList } from '@/utils/permission'
import Breadcrumb from './Breadcrumb'

export default {
  components: { Breadcrumb },
  data() {
    return {
      cacheLoading: false,
      subSiteIdLocal: 0
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'subSiteList', 'subSiteId', 'isStationAdmin', 'substationName'])
  },
  watch: {
    subSiteId: {
      immediate: true,
      handler(val) {
        this.subSiteIdLocal = val
      }
    }
  },
  created() {
    if (!this.isStationAdmin && !this.subSiteList.length
        && canLoadSubsiteList(this.$store.getters.permissions)) {
      this.$store.dispatch('app/loadSubSites')
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async refreshCache() {
      this.cacheLoading = true
      try {
        await clearCache()
        this.$message.success('缓存已更新')
      } finally {
        this.cacheLoading = false
      }
    },
    onSubstationChange(id) {
      this.$store.dispatch('app/setSubSiteId', id)
      this.$message.success('已切换驿站')
    },
    async handleCommand(cmd) {
      if (cmd === 'logout') {
        await this.$store.dispatch('user/logout')
        this.$router.push('/login')
      }
    }
  }
}
</script>
